<template>
  <section class="vcenter">
    <form
      class="vcenter-form"
      @submit.prevent="submit"
    >

      <h1>Mot de passe oublié</h1>

      <b-message
        v-if="done"
        type="is-success"
        has-icon
      >
        <p>L'email de réinitialisation de votre mot de passe vient d'être envoyé.</p>
        <p>Consultez votre boite mail.</p>
      </b-message>

      <template v-else>

        <b-message
          v-if="errorMessage"
          type="is-danger"
        >
          {{ errorMessage }}
        </b-message>

        <b-field label="Adresse email">
          <b-input
            v-model="email"
            type="email"
          />
        </b-field>

        <div class="form-buttons">
          <button
            class="button is-primary"
            type="submit"
          >
            Valider
          </button>
          <div class="right">
            <router-link
              class="small"
              to="/"
            >
              Retour
            </router-link>
          </div>
        </div>

      </template>

      <b-loading
        :active="loading"
        :is-full-page="false"
      />
    </form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      errorMessage: null,
      done: false,
      loading: false,
    }
  },
  created () {
    if (process.env.NODE_ENV === 'dev') {
      this.email = 'simon@tarchichi.com'
    }
  },
  methods: {
    async submit () {
      this.errorMessage = null
      if (!this.email) {
        this.errorMessage = 'Vous devez préciser une adresse email'
        return
      }
      this.loading = true
      try {
        await this.$api.post('/login/password-reset', {
          email: this.email,
        })
        this.done = true
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          this.errorMessage = e.response.data.error
        } else {
          this.errorMessage = e.message || 'Erreur lors de la réinitialisation'
        }
      }
      this.loading = false
    },
  }
}
</script>

<style lang="scss" scoped>
.message-body {
  p + p {
    margin-top: 1em;
  }
}
</style>
